import React from 'react';
import PropTypes from 'prop-types';

function SwitchIcon({ fill, width, height, stroke, border }) {
  return (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="35.389" y="0.65172" width={width}  height={height} rx="17" transform="rotate(89.6226 35.389 0.65172)" fill={fill}/>
      <rect x="35.389" y="0.65172" width={width}  height={height} rx="17" transform="rotate(89.6226 35.389 0.65172)" stroke={border}/>
      <path d="M10.9777 13.4633L15.6007 8.77903L20.285 13.402L19.2228 14.463L16.3696 11.647L16.4176 18.9276L14.9176 18.9375L14.8697 11.6569L12.0537 14.5103L10.9777 13.4633ZM16.724 23.1182L17.7862 22.0572L20.6396 24.8732L20.5917 17.5926L22.0914 17.5827L22.1393 24.8633L24.9553 22.0099L26.0315 23.0569L21.4085 27.7412L16.724 23.1182Z" fill={stroke}/>
    </svg>
  );
}

SwitchIcon.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  border: PropTypes.string
};

SwitchIcon.defaultProps = {
  fill: '#F8F9FB',
  width: '34',
  height: '34',
  stroke: '#252525',
  border: '#1C2938'
};

export default SwitchIcon;
